/** @format */

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrder,
  getAllOrders,
  getOrderDetailes,
  updateOrder,
} from "../../services/dashboard";

import { RenderStatus } from "../../components/global/table-components";
import { statusValues } from "../../constant/table";
// import "./index.scss";
import { DateFormatter } from "../../utilities/helper";
import Button from "../../components/Button";
import Icons from "../../Assets/Icons";
import { Spinner1 } from "../../components/spinners/Spinner1";
import ActionModal from "../../components/pops/global modals/action-modal";
import AccordionComponent from "../../components/Accordion";
let dataConstant = [
  { key: "id", label: "Id " },
  { key: "created_at", label: "تاريخ الطلب " },
  { key: "name", label: "اسم الكفيل " },
  { key: "serviceName", label: "اسـم الخدمة " },
  { key: "total", label: "سعر الخدمة " },
  { key: "from", label: "توصيل من " },
  { key: "to", label: "توصيل الي " },
  { key: "appointment_date", label: "موعد الحجز " },
];
export default function OrderDetails() {
  const [isOpen, setOpen] = useState(false);
  const [selectedAction, setActionObj] = useState({});
  const navigate = useNavigate();
  const { orderDetailes, loading } = useSelector((state) => state.orders);
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrderDetailes({ id: id }));
  }, []);

  const toggleModal = (flag) => {
    setOpen(flag ?? !isOpen);
  };

  const acceptOrder = () => {
    updateOrderStatus("processing");
  };
  const cancelOrder = () => {
    updateOrderStatus("cancelled");
  };
  const updateOrderStatus = (status) => {
    let params = { status: status };
    dispatch(updateOrder({ id: id, params: params })).then((res) => {
      setOpen(false);
      dispatch(getOrderDetailes({ id: id }));
    });
  };
  const deleteOrderHandler = () => {
    dispatch(deleteOrder({ id: id })).then((res) => {
      navigate("/history");
    });
  };
  let modalOj = {
    delete: {
      title: "هل تريد حذف هذا الطلب ؟",
      action: deleteOrderHandler,
    },
    approve: {
      title: "هل تريد قبول هذا الطلب ؟",
      action: acceptOrder,
    },
    cancel: {
      title: "هل تريد رفض هذا الطلب ؟",
      action: cancelOrder,
    },
  };
  const actionBtn = (buttonName) => {
    setOpen(true);

    setActionObj(modalOj[buttonName]);
  };

  return (
    <NavbarAndSidebar>
      <ActionModal
        data={orderDetailes}
        showModal={isOpen}
        setShowModal={toggleModal}
        msg={selectedAction.title}
        action={selectedAction.action}
      />
      {loading && <Spinner1 />}
      <div className='orderDetails-cont'>
        <div className='orderDetails-cont__header'>
          <div>
            <h3>حـالة الطلب :</h3>{" "}
            <RenderStatus data={statusValues[orderDetailes.status]} />
          </div>
          <div>
            {orderDetailes.status === "pending" ? (
              <div>
                <Button
                  customStyle='orange'
                  title='قبول'
                  action={() => actionBtn("approve")}
                />
                <Button
                  customStyle='red'
                  title='رفض'
                  action={() => actionBtn("cancel")}
                />
              </div>
            ) : (
              <Button
                customStyle='orange'
                title='رجوع'
                action={() => navigate("/history")}
              />
            )}
            <Button
              customStyle='red'
              title='حذف'
              action={() => actionBtn("delete")}
            />
          </div>
        </div>
        <div className='orderDetails-cont__order-body'>
          <div className='orderDetails-cont__order-body__column'>
            {dataConstant.map((item) => (
              <div className='orderDetails-cont__order-body__column__row'>
                <h5>{item.label} :</h5> <span>{orderDetailes[item.key]}</span>
              </div>
            ))}
          </div>
          <div className='orderDetails-cont__order-body__column'>
            <div className='orderDetails-cont__order-body__column__papers-headers'>
              <h5>حالة الاوراق </h5>
              <RenderStatus data={orderDetailes.verified ? "تم" : "مرفوض"} />
            </div>
            {orderDetailes.verified === 0 && (
              <div className='orderDetails-cont__order-body__column__papers-headers '>
                <h5> سبب رفض الاوراق :</h5> <span></span>
              </div>
            )}
            <div className='orderDetails-cont__order-body__column__papers-body'>
              <h5> الاوراق</h5>
              <Icons name={orderDetailes.verified ? "verified" : "notvalid"} />
            </div>

            <div className='orderDetails-cont__order-body__column__papers-images'>
              <AccordionComponent
                title='بطاقة الكفيل'
                img1={orderDetailes.image_back}
                img2={orderDetailes.image_front}
              />
              <AccordionComponent
                title='جواز السفر العامل / العاملة المنزلية'
                img1={orderDetailes.image_passport}
                img2={orderDetailes.image_front}
              />
              <AccordionComponent
                title='التذكرة عامل / العاملة المنزلية'
                img1={orderDetailes.image_ticket}
              />
            </div>
          </div>
        </div>
      </div>
    </NavbarAndSidebar>
  );
}
